import { oidcEntity } from '@/oidc'
import { createRouter, createWebHistory } from 'vue-router'
import { useToast } from 'vue-toastification'
import { checkSidebar, createAuthenticate, createLanguageQueryCheck, isMobile, guardMobileRoutes } from './utils'
import { routes } from './routes'

const toast = useToast()

const user = oidcEntity

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

const authenticate = createAuthenticate(router, user, toast)
const checkLanguageQuery = createLanguageQueryCheck(router)

// Navigation Global Guards
router.beforeEach((to, from, next) => {
  authenticate(to)
  checkLanguageQuery(to)
  guardMobileRoutes(to, from, next)
})

router.afterEach((to) => {
  checkSidebar(to)
})

user.addUserChangeHandler(() => {
  // User changed Navigation check
  authenticate(router.currentRoute.value)
})

export default router
export { routes }
